import React from "react";
import { Box, Select, MenuItem, Typography } from "@mui/material";

const SelectTimePicker = ({
  label,
  hour,
  minute,
  onHourChange,
  onMinuteChange,
  disabled,
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {label && <Typography variant="subtitle2">{label}</Typography>}
      <Select
        value={hour}
        onChange={onHourChange}
        size="small"
        variant="standard"
        sx={{ height: "40px" }}
        disabled={disabled}
      >
        {[...Array(24).keys()].map((h) => (
          <MenuItem key={h} value={h}>
            {h.toString().padStart(2, "0")}
          </MenuItem>
        ))}
      </Select>

      <Box fontWeight={"bold"}>:</Box>

      <Select
        value={minute}
        onChange={onMinuteChange}
        size="small"
        variant="standard"
        sx={{ height: "40px" }}
        disabled={disabled}
      >
        {[...Array(12).keys()].map((m) => {
          const val = m * 5;
          return (
            <MenuItem key={val} value={val}>
              {val.toString().padStart(2, "0")}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};

export default SelectTimePicker;
